// .3 strengthens behavior grading and balances the React quiz (9 questions).
// Historical attempts keep their own version, answers, deadlines, and scores.
export const CONTENT_VERSION = "2026.09.12.3";
export const LEGACY_CONTENT_VERSIONS = [
  "2026.09.12.1",
  "2026.09.12.2",
] as const;
export function isKnownContentVersion(value: unknown): value is string {
  return (
    typeof value === "string" &&
    (value === CONTENT_VERSION ||
      LEGACY_CONTENT_VERSIONS.some((version) => version === value))
  );
}
